import MaterialTable from "material-table";
import React from "react";
import tableIcons, { options } from "components/universal/table_attributes";
import { Typography } from "@material-ui/core";

const SetupTable = (props) => {
  const {
    loading,
    page,
    pageSize,
    totalCount,
    setPage,
    setPageSize,
    handleClickUser,
    handleClickUserGroups,
    tableData,
  } = props;

  const tableOptions = {
    ...options,
    page,
    total: totalCount,
    pageSize,
    search: false,
    toolbar: false,
  };

  const columns = [
    {
      title: "Report #",
      field: "id",
      headerStyle: {
        textAlign: "left",
        width: "7%",
        paddingLeft: "15px",
      },
      cellStyle: {
        width: "7%",
        paddingLeft: "15px",
      },
    },

    {
      title: "Category",
      field: "category",
      headerStyle: {
        width: "7%",
        textAlign: "left",
      },
      cellStyle: {
        width: "7%",
        textAlign: "left",
      },
    },

    {
      title: "Name",
      field: "name",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
      },
    },

    {
      title: "User Groups",
      field: "count_report_user_groups",
      headerStyle: {
        width: "7%",
      },
      cellStyle: {
        width: "7%",
      },
      render: (rowData) => (
        <div
          onClick={() => handleClickUserGroups(rowData)}
          style={{
            backgroundColor: "transparent",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <Typography
            variant="body2"
            style={{ textDecoration: "underline", color: "#265AE8" }}>
            {rowData?.count_report_user_groups ?? 0}
          </Typography>
        </div>
      ),
    },

    {
      title: "Users",
      field: "count_report_users",
      headerStyle: {
        width: "7%",
      },
      cellStyle: {
        width: "7%",
      },
      render: (rowData) => (
        <div
          onClick={() => handleClickUser(rowData)}
          style={{
            backgroundColor: "transparent",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <Typography
            variant="body2"
            style={{ textDecoration: "underline", color: "#265AE8" }}>
            {rowData?.count_report_users ?? 0}
          </Typography>
        </div>
      ),
    },
  ];
  const tableStyle = { boxShadow: "0px 1px 3px #00000033" };
  const localization = {
    body: {
      emptyDataSourceMessage: "No Reports found",
    },
  };
  const handlePageChange = (changedPage) => setPage(changedPage);
  const handlePageSizeChange = (changedPageSize) =>
    setPageSize(changedPageSize);

  return (
    <MaterialTable
      style={tableStyle}
      icons={tableIcons}
      title={""}
      columns={columns}
      data={tableData}
      isLoading={loading}
      options={tableOptions}
      localization={localization}
      onChangePage={handlePageChange}
      onChangeRowsPerPage={handlePageSizeChange}
      totalCount={totalCount}
      page={page}
    />
  );
};

export default SetupTable;
